import { render, staticRenderFns } from "./ChampionshipChampInfo.vue?vue&type=template&id=5892cad0&"
import script from "./ChampionshipChampInfo.vue?vue&type=script&lang=js&"
export * from "./ChampionshipChampInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports